import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({

})

/**
 * <EditTemplateDialog template onUpdateTemplate = {template} onCancel = {} />
 */

class EditTemplateDialog extends Component {

	state = {
		name: ""
	}

	isReadyToUpdate() {
		if (this.state.name === "") {
			return false
		}
		if (this.state.name !== this.props.template.name) {
			return true
		}
		return false
	}

	componentDidMount(prevProps) {
		this.setState({
			name: this.props.template.name,
		})
	}

	render() {
		return <Dialog
			open = {true}
			scroll = "body"
		>
			<DialogTitle>
				Редактировать шаблон
			</DialogTitle>
			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				<TextField
					value = {this.state.name}
					label = "Название шаблона"
					margin = "normal"
					onChange = {e => {
						this.setState({
							name: e.target.value
						})
					}}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					disabled = {!this.isReadyToUpdate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onUpdateTemplate === "function") {
							this.props.onUpdateTemplate({
								id: this.props.template.id,
								name: this.state.name,
							})
						}
					}}
				>Сохранить</Button>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>
			</DialogActions>
		</Dialog>

	}

}

export default withStyles(styles)(EditTemplateDialog)
